import { Get, Put, Post } from "./api";

export const getPax = async () => {
  const result = await Get('/api/pax');

  return result.data;
};

export const getPaxStats = async () => {
  const result = await Get('/api/pax/stats');

  return result.data;
};

export const getPaxByID = async (paxId) => {
  const result = await Get(`/api/pax/${paxId}`);

  return result.data;
};

export const updatePax = async (paxId, data) => {
  const result = await Put(`/api/pax/${paxId}`, data);

  return result.data;
};

export const mergePax = async (sourcePaxId, targetPaxId) => {
  const result = await Post(`/api/pax/${sourcePaxId}/merge`, { targetPaxId });

  return result.data;
};
